import React from 'react';
import { Section } from './ui';
import { TrendingUp, Users, CheckCircle2 } from 'lucide-react';
export const CoursePillars = () => {
  const negocio = ['Empezar sin stock propio', 'Vender por pedido', 'Conseguir proveedores', 'Evitar comprar mal', 'Entender modelos y oportunidades'];
  const marketing = ['Conseguir clientes con Instagram', 'Usar WhatsApp para vender por conversación', 'Crear contenido con intención comercial', 'Usar Meta Ads', 'Evitar atraer solo curiosos'];
  return <Section className="bg-white/[0.02] border-y border-white/[0.05] backdrop-blur-sm" data-id="element-20">
      <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-21">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-22">
          Qué vas a aprender
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto" data-id="element-23">
        <div className="bg-zinc-900/60 backdrop-blur-sm md:backdrop-blur-md border border-white/[0.05] rounded-3xl p-6 md:p-8 shadow-md md:shadow-xl" data-id="element-24">
          <div className="flex items-center mb-6" data-id="element-25">
            <div className="w-12 h-12 rounded-full bg-blue-500/10 flex items-center justify-center mr-4" data-id="element-26">
              <TrendingUp className="w-6 h-6 text-blue-500" data-id="element-27" />
            </div>
            <h3 className="text-2xl font-bold text-white" data-id="element-28">
              Negocio / Operación
            </h3>
          </div>
          <ul className="space-y-4" data-id="element-29">
            {negocio.map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-30">
                <CheckCircle2 className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" data-id="element-31" />
                <span className="text-zinc-300" data-id="element-32">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="bg-zinc-900/60 backdrop-blur-sm md:backdrop-blur-md border border-white/[0.05] rounded-3xl p-6 md:p-8 shadow-md md:shadow-xl" data-id="element-33">
          <div className="flex items-center mb-6" data-id="element-34">
            <div className="w-12 h-12 rounded-full bg-emerald-500/10 flex items-center justify-center mr-4" data-id="element-35">
              <Users className="w-6 h-6 text-emerald-500" data-id="element-36" />
            </div>
            <h3 className="text-2xl font-bold text-white" data-id="element-37">
              Marketing / Ventas
            </h3>
          </div>
          <ul className="space-y-4" data-id="element-38">
            {marketing.map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-39">
                <CheckCircle2 className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-40" />
                <span className="text-zinc-300" data-id="element-41">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
};
export const Instructors = () => {
  return <Section data-id="element-42">
      <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-43">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-44">
          Quiénes te enseñan
        </h2>
      </div>
      <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-45">
        <div className="bg-zinc-900/50 backdrop-blur-sm md:backdrop-blur-md border border-white/[0.05] rounded-2xl p-6 shadow-md" data-id="element-46">
          <div className="flex items-center mb-3" data-id="element-47">
            <div className="w-10 h-10 rounded-full bg-blue-500/10 flex items-center justify-center mr-3" data-id="element-48">
              <TrendingUp className="w-5 h-5 text-blue-500" data-id="element-49" />
            </div>
            <h3 className="text-xl font-bold text-white" data-id="element-50">Nico</h3>
          </div>
          <p className="text-zinc-400 leading-relaxed" data-id="element-51">
            Negocio, operación, venta sin stock y proveedores.
          </p>
        </div>
        <div className="bg-zinc-900/50 backdrop-blur-sm md:backdrop-blur-md border border-white/[0.05] rounded-2xl p-6 shadow-md" data-id="element-52">
          <div className="flex items-center mb-3" data-id="element-53">
            <div className="w-10 h-10 rounded-full bg-emerald-500/10 flex items-center justify-center mr-3" data-id="element-54">
              <Users className="w-5 h-5 text-emerald-500" data-id="element-55" />
            </div>
            <h3 className="text-xl font-bold text-white" data-id="element-56">Damian</h3>
          </div>
          <p className="text-zinc-400 leading-relaxed" data-id="element-57">
            Contenido, Instagram, WhatsApp, Meta Ads y ventas por conversación.
          </p>
        </div>
      </div>
    </Section>;
};